import { IAdminContact } from './IAdminContact';
import { IPresentationContactData } from './IPresentationContactData';

export interface IInternalContactRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  notes?: string;
  roles: string[];
  phoneNumber: string | null;
  phoneExtension?: number;
  timeZone?: string;
  emailAddress: string;
  externalEmail: string;
  admin: IAdminContact;
}

export interface IInternalContactResponse extends IInternalContactRequest {
  roles: string[];
}

// Type for sending update request body to the API (uses string[] for roles)
export type IUpdateInternalContactRequest = IInternalContactRequest;

export type IInternalContactData = IInternalContactResponse;

export type IPresentationInternalContact = IPresentationContactData<IInternalContactData, string>;

export const convertFromIInternalContactsDataToIInternalContactsRequest = (
  data: IInternalContactData,
): IUpdateInternalContactRequest => data;
